import axios from 'axios';

/**
 * @param {string} to - Destination email address
 * @param {string} subject - Email ka subject
 * @param {string} htmlContent - Pura HTML template 
 */
export const sendHtmlEmail = async (to, subject, htmlContent) => {
    const API_URL = "https://emailapi.smsboom.in/send-email";

    const payload = {
        to: to,
        subject: subject,
        htmlContent: htmlContent
    };

    try {
        const response = await axios.post(API_URL, payload);
        console.log("API Response Object:", response.data); // 
        return response.data; 
    } catch (error) {
        console.error("Email API Error:", error.response ? error.response.data : error.message);
        throw error;
    }
};